// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import '../../i18n/nl-BE';

import error from './error';

error();
